var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVpcListStorage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#8793A3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.278 10.444v11-11zM22.722 10.444v11-11zM22.722 21.444c0 1.35-3.01 2.445-6.722 2.445-3.713 0-6.722-1.095-6.722-2.445"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.722 14.111c0 1.35-3.01 2.445-6.722 2.445-3.713 0-6.722-1.095-6.722-2.445M22.722 17.778c0 1.35-3.01 2.444-6.722 2.444-3.713 0-6.722-1.094-6.722-2.444M22.722 10.444c0 1.35-3.01 2.445-6.722 2.445-3.713 0-6.722-1.095-6.722-2.445",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.722 10.444C22.722 9.094 19.712 8 16 8c-3.713 0-6.722 1.094-6.722 2.444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVpcListStorage);
export default __webpack_public_path__ + "static/media/ico-vpc-list-storage.6b19d0844feddbf540234ce770250e5a.svg";
export { ForwardRef as ReactComponent };